import { AjaxService } from "../shared/services/AjaxService";
import type { ResponseModel } from "../models/ResponseModel";

export type GetApiVersionRequestDto = {
  platformId: string;
  currentVersion?: string;
};

export type GetApiVersionResponseDto = {
  latestVersion: string;
  isUpdateAvailable: boolean;
  redirectUrl?: string | null;
  title?: string | null;
  description?: string | null;
};

export type GetApiVersionApiResponse = ResponseModel & {
  data?: GetApiVersionResponseDto;
};

export type GetVersionDetailsRequestDto = {
  platformId: string;
  currentVersion: string;
};

export type GetVersionDetailsResponseDto = {
  versionNumber: string;
  title?: string | null;
  description?: string | null;
  createdDateTime: string;
};

export type GetVersionDetailsApiResponse = ResponseModel & {
  data?: GetVersionDetailsResponseDto;
};

export const AppVersionService = {
  async getApiVersion(
    payload: GetApiVersionRequestDto
  ): Promise<GetApiVersionApiResponse> {
    
    return AjaxService.post<GetApiVersionApiResponse>(
      "/AppVersion/get-api-version",
      payload,
      {
        includeSessionAuth: false,
        clearSessionOnUnauthorized: false,
      }
    );
  },

  async getVersionDetails(
    payload: GetVersionDetailsRequestDto
  ): Promise<GetVersionDetailsApiResponse> {
    
    return AjaxService.post<GetVersionDetailsApiResponse>(
      "/AppVersion/get-version-details",
      payload,
      {
        includeSessionAuth: false,
        clearSessionOnUnauthorized: false,
      }
    );
  },
};
